import { ErrorPageComponent } from '@jablotron/lib.spa-components';
import { captureException } from '@jablotron/lib.spa-sentry';
import { ErrorComponentProps } from '@tanstack/react-router';
import { isNotFound, PathParamError, SearchParamError } from '@tanstack/router-core';
import { NotFoundPage } from '~/pages/not-found';

export const DefaultErrorComponent: React.FC<ErrorComponentProps> = ({ error, info }) => {
  captureException(error, { data: { info } });
  switch (true) {
    case isNotFound(error):
    case error instanceof PathParamError:
    case error instanceof SearchParamError:
      return <NotFoundPage />;
    default:
      return <ErrorPageComponent />;
  }
};
